export default "__VITE_ASSET__46bHYTFD__"